import { render } from "./MarketplaceLogin.vue?vue&type=template&id=7c8ac924"
import script from "./MarketplaceLogin.vue?vue&type=script&lang=js"
export * from "./MarketplaceLogin.vue?vue&type=script&lang=js"

import "./MarketplaceLogin.vue?vue&type=style&index=0&id=7c8ac924&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__